import { render } from "./XIconSolidUserCog.vue?vue&type=template&id=285bddfa"
import script from "./XIconSolidUserCog.vue?vue&type=script&lang=js"
export * from "./XIconSolidUserCog.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidUserCog.vue"]])

export default __exports__